const listTab = {
  FACheckup: 'FA Checkup',
  financialRatio: 'Financial Ratio',
  ZMFScore: 'ZMF Score',
};

const listTicker = {
  ORGAN_CODE: 'organCode',
  TICKER: 'ticker',
  ORGAN_SHORT_NAME: 'organShortName',
  COM_GROUP_CODE: 'comGroupCode',
  COM_TYPE_CODE: 'comTypeCode',
};

const listIndexName = {
  vnIndex: 'VNINDEX',
  hnIndex: 'HNXINDEX',
  upcomIndex: 'UPCOMINDEX',
};

const listIndexExchange = {
  hose: 'HOSE',
  hnx: 'HNX',
  upcom: 'UPCOM',
};

const industry = {
  //non-bank
  mc: 'rsd11',
  os: 'rsd3',
  eps: 'rsd14',
  pe: 'rsd21',
  pb: 'rsd25',
  ps: 'rsd26',
  pcf: 'rsd28',
  bvps: 'rsd7',
  ee: 'rsd30',

  rg: 'rsq34',
  eg: 'rsq37',
  roic: 'rsq76',
  gpm: 'rsq25',
  npm: 'rsq29',

  cur: 'rsq3',
  car: 'rsq1',
  fl: 'rsq71',
  ic: 'rsq77',

  dso: 'rsq16',
  dpo: 'rsq20',
  dio: 'rsq18',
  at: 'rsq31',

  dy: 'rsd20',
  dpy: 'rsd51',

  //bank
  dg: 'rsq51',
  lg: 'rsq50',
  niig: 'rsq67',
  npg: 'rsq39',
  roe: 'rsq12',
  roa: 'rsq14',
  nim: 'rsq44',
  cir: 'rsq48',
  nn: 'rsq47',
  yoea: 'rsq45',
  acof: 'rsq46',

  eli: 'rsq54',
  elo: 'rsq55',
  ea: 'rsq56',
  ldr: 'rsq57',

  npl: 'rsq58',
  llrn: 'rsq59',
  llrl: 'rsq60',
  pol: 'rsq61',
};

const FATable = {
  bank: {
    vr: {
      mc: 'rtd11',
      os: 'rtd3',
      eps: 'rtd14',
      pe: 'rtd21',
      pb: 'rtd25',
      bvps: 'rtd7',
    },
    pr: {
      dg: 'rtq51',
      lg: 'rtq50',
      niig: 'rtq67',
      npg: 'rtq83',
      roe: 'ryq12',
      roa: 'ryq14',
      nim: 'ryq44',
      cir: 'ryq48',
      nn: 'ryq47',
      yoea: 'ryq45',
      acof: 'ryq46',
    },
    car: {
      eli: 'ryq54',
      elo: 'ryq55',
      ea: 'ryq56',
      ldr: 'ryq57',
    },
    aqr: {
      npl: 'ryq58',
      llrn: 'ryq59',
      llrl: 'ryq60',
      pol: 'ryq61',
    },
    d: {
      dy: 'ryd20',
      dpy: 'ryd51',
    },
  },
  nonBank: {
    vr: {
      mc: 'rtd11',
      os: 'rtd3',
      eps: 'rtd14',
      pe: 'rtd21',
      pb: 'rtd25',
      ps: 'rtd26',
      pcf: 'rtd28',
      bvps: 'rtd7',
      ee: 'rtd30',
    },
    pr: {
      rg: 'rtq78',
      eg: 'rtq81',
      npg: 'rtq83',
      roe: 'ryq12',
      roic: 'ryq76',
      roa: 'ryq14',
      gpm: 'ryq25',
      npm: 'ryq29',
    },
    lr: {
      cur: 'ryq3',
      car: 'ryq1',
      fl: 'ryq71',
      ic: 'ryq77',
    },
    or: {
      dso: 'ryq16',
      dpo: 'ryq20',
      dio: 'ryq18',
      at: 'ryq31',
    },
    d: {
      dy: 'ryd20',
      dpy: 'ryd51',
    },
  },
};

export const specialTtmKeysSwap = {
  ryd11: 'rtd11',
  ryd3: 'rtd3',
  ryd14: 'rtd14',
  ryd21: 'rtd21',
  ryd25: 'rtd25',
  ryd26: 'rtd26',
  ryd28: 'rtd28',
  ryd7: 'rtd7',
  ryd30: 'rtd30',
  rtq78: 'rtq78',
  rtq81: 'rtq81',
  ryq76: 'rtq76',
  ryq25: 'rtq25',
  ryq29: 'rtq29',

  ryq3: 'rtq3',
  ryq1: 'rtq1',
  ryq71: 'rtq71',
  ryq77: 'rtq77',

  ryq16: 'rtq16',
  ryq20: 'rtq20',
  ryq18: 'rtq18',
  ryq31: 'rtq31',

  rtq51: 'rtq51',
  rtq50: 'rtq50',
  rtq67: 'rtq67',
  rtq83: 'rtq83',
  ryq12: 'rtq12',
  ryq14: 'rtq14',
  ryq44: 'rtq44',
  ryq48: 'rtq48',
  ryq47: 'rtq47',
  ryq45: 'rtq45',
  ryq46: 'rtq46',

  ryq54: 'rtq54',
  ryq55: 'rtq55',
  ryq56: 'rtq56',
  ryq57: 'rtq57',

  ryq58: 'rtq58',
  ryq59: 'rtq59',
  ryq60: 'rtq60',
  ryq61: 'rtq61',

  ryd20: 'rtd20',
  ryd51: 'rtd51',

  ryq69: 'rtq69',
};

const assetQualityChart = {
  bank: {
    ta: 'bsa53',
    tl: 'bsb103',
    tnpl: 'ryq69',
    npl: 'ryq58',
  },
};

const assetQualityChartTitle = {
  bank: {
    ta: 'Total Assets',
    tl: 'Total Loans',
    tnpl: 'Total Non-performing Loan',
    npl: 'NPL',
  },
};

const dupontChart = {
  bank: null,
  nonBank: {
    roe: 'ryq12',
    npm: 'ryq29',
    fl: 'ryq71',
    tat: 'ryq31',
  },
};

const dupontChartTitle = {
  bank: null,
  nonBank: {
    roe: 'ROE',
    npm: 'Net Profit Margin',
    fl: 'Financial Leverage',
    tat: 'Total Asset Turnover',
  },
};

const profitabilityChart = {
  bank: {
    roe: 'rtq12',
    roa: 'rtq14',
    nim: 'rtq44',
    cir: 'rtq48',
  },
  nonBank: {
    roe: 'rtq12',
    roa: 'rtq14',
    gpm: 'rtq25',
    npm: 'rtq29',
  },
  industry: {
    roe: 'rsq12',
    roa: 'rsq14',
    nim: 'rsq44',
    gpm: 'rsq25',
    npm: 'rsq29',
    cir: 'rsq48',
  },
};

const profitabilityTitle = {
  bank: {
    roe: '%ROE',
    roa: '%ROA',
    nim: '%NIM',
    cir: '%CIR',
  },
  nonBank: {
    roe: '%ROE',
    roa: '%ROA',
    npm: 'NPM',
    gpm: 'GPM',
  },
};

const profitabilityTooltip = {
  bank: {
    roe: '%ROE',
    roa: '%ROA',
    nim: '%NIM',
    cir: '%CIR',
  },
  nonBank: {
    roe: '%ROE',
    roa: '%ROA',
    npm: 'Net Profit Margin',
    gpm: 'Gross Profit Margin',
  },
};

const realTimeData = {
  MATCH_PRICE: 'matchPrice',
  PRICE_CHANGE: 'priceChange',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  OPEN_PRICE: 'openPrice',
  HIGHEST_PRICE: 'highestPrice',
  LOWEST_PRICE: 'lowestPrice',
  REFERENCE_PRICE: 'referencePrice',
  TRADING_DATE: 'tradingDate',
  CEILING_PRICE: 'ceilingPrice',
  FLOOR_PRICE: 'floorPrice',
};

export default {
  listTab,
  listTicker,
  listIndexName,
  listIndexExchange,
  dupontChart,
  profitabilityChart,
  profitabilityTitle,
  FATable,
  industry,
  realTimeData,
  dupontChartTitle,
  profitabilityTooltip,
  specialTtmKeysSwap,
  assetQualityChart,
  assetQualityChartTitle,
};
